export default {
  Settings: {
    AuthUserTemplate: {
      TitleIndex: 'الگو های رد احراز',
      Add: 'افزودن الگوی جدید',
      Title: 'عنوان',
      Content: 'محتوا',
      Templates: 'الگوها',
      Modal: {
        TitleAdd: 'افزودن الگوی جدید',
        TitleUpdate: 'ویرایش الگو',
      },
    },
  },
}
